import { useNavigate } from "react-router-dom";
import styles from "./GifteeFlowHeader.module.css";

/**
 * Giftee flow top bar from Figma node 501:16042 (status bar omitted).
 * Title uses Title/Small tokens; close matches circular white control and goes back in history.
 * Home (Figma 501:15782): pass `welcomeHeadline` instead of `title`, and `showClose={false}`.
 */
export default function GifteeFlowHeader({
  title,
  welcomeHeadline,
  showClose = true,
  className,
  onClose,
}) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (typeof onClose === "function") {
      onClose();
      return;
    }
    navigate(-1);
  };

  const headline =
    typeof welcomeHeadline === "string" && welcomeHeadline.trim()
      ? welcomeHeadline.trim()
      : (title ?? "");

  return (
    <header className={[styles.root, className].filter(Boolean).join(" ")}>
      <h1 className={styles.title}>{headline}</h1>
      {showClose ? (
        <button
          type="button"
          className={styles.closeBtn}
          onClick={handleClose}
          aria-label="Close"
        >
          <i className="fa-solid fa-xmark" aria-hidden />
        </button>
      ) : (
        <span className={styles.closeSpacer} aria-hidden="true" />
      )}
    </header>
  );
}
